<template>
    <div class="MobileMenu">
        <span @click="toggleSideMenu">
            <MenuIcon class="menuIcon" />
        </span>
        <SideMenu :menuToggler="toggleSideMenu" :isActive="menuActive" />
    </div>
</template>

<script>
import MenuIcon from 'vue-material-design-icons/Menu.vue'
import SideMenu from '@/components/MobileMenu/SideMenu'

export default {
    name: 'MobileMenu',
    components: {
        MenuIcon,
        SideMenu
    },
    data() {
        return {
            menuActive: false
        }
    },
    watch: {
        menuActive() {
            document.body.style.overflow = this.menuActive ? 'hidden' : ''
        }
    },
    methods: {
        toggleSideMenu() {
            this.menuActive = !this.menuActive
        }
    }
}
</script>

<style lang="scss" scoped>
.MobileMenu {
    z-index: 10;

    .menuIcon {
        font-size: 2.5em;
        margin-top: -10px;
        color: $grey;
    }
}

@media screen and (min-width: 1024px) {
    .MobileMenu {
        display: none;
    }
}
</style>
